import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";

const http = axios.create({ withCredentials: true });
export const customerApi = {
  me: async () => (await http.get(`${API}/customer/me`)).data,
  register: async (body) => (await http.post(`${API}/customer/register`, body)).data,
  login: async (body) => (await http.post(`${API}/customer/login`, body)).data,
  logout: async () => (await http.post(`${API}/customer/logout`)).data,
  update: async (body) => (await http.put(`${API}/customer/me`, body)).data,
  orders: async () => (await http.get(`${API}/customer/orders`)).data,
  forgot: async (email) => (await http.post(`${API}/customer/forgot-password`, { email })).data,
  reset: async (token, password) => (await http.post(`${API}/customer/reset-password`, { token, password })).data,
};

export const apiError = (e, fallback = "Algo ha ido mal. Inténtalo de nuevo.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg.replace(/^Value error, /, "") : "")).filter(Boolean).join(" · ") || fallback;
  return fallback;
};

const Ctx = createContext({ user: null, setUser: () => {}, logout: async () => {} });

export const CustomerProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = guest
  useEffect(() => {
    if (!API) { setUser(false); return undefined; }
    customerApi.me().then(setUser).catch(() => setUser(false));
    return undefined;
  }, []);
  const logout = useCallback(async () => { await customerApi.logout().catch(() => {}); setUser(false); }, []);
  return <Ctx.Provider value={{ user, setUser, logout }}>{children}</Ctx.Provider>;
};

export const useCustomer = () => useContext(Ctx);
